import React, { Component } from "react";
import sectiondata from "../../data/sections.json";
import parse from "html-react-parser";

import { useDispatch, useSelector } from "react-redux";
import { propertyFetchThunk } from "../../features/properties/properties";
import { Link } from "react-router-dom";

function RecomandProperties() {
  let publicUrl = "../../";
  let imagealt = "image";
  let data = sectiondata.recinabdproperties;

  const dispatch = useDispatch();

  const propertyState = useSelector((state) => state.properties);

  React.useEffect(() => {
    dispatch(propertyFetchThunk());
    return () => {};
  }, []);

  return (
    <div className="recommended-area pd-top-90 pd-bottom-70">
      <div className="container">
        <div className="section-title">
          <h2 className="title">{data.title}</h2>
          <a className="btn-view-all" href="/search-map">
            View All
          </a>
        </div>
        <div className="row">
          {propertyState.properties.slice(0, 4).map((item, i) => (
            <div key={i} className="col-lg-3 col-sm-6">
              <div className="single-feature">
                <div className="thumb">
                  <img src={item.selectedFile[0]} alt="img" />
                </div>
                <div className="details">
                  <a href="#" className="feature-logo">
                    <img src={"assets/img/icons/l3.png"} alt={imagealt} />
                  </a>
                  <p className="author">
                    <i className="fa fa-user" /> {item.authorName}
                  </p>
                  <h6 className="title">
                    <Link
                      to={{
                        pathname: "property-details",
                        state: { propertyDetail: item },
                      }}
                    >
                      {item.title}
                    </Link>
                  </h6>
                  <h6 className="price">{item.totalPayment}</h6>
                  <del>{item.totalPayment}</del>
                  <ul className="info-list">
                    {item.keyFeatures.map((features, i) => (
                      <li key={i}>
                        <i className={features.icon} /> {features.title}
                      </li>
                    ))}
                    <li>
                      <img
                        src={publicUrl + "/assets/img/icons/7.png"}
                        alt={imagealt}
                      />{" "}
                      {item.area}
                    </li>
                  </ul>
                  <ul className="contact-list">
                    <li>
                      <a className="phone" href="#">
                        <i className="fa fa-phone" />
                      </a>
                    </li>
                    <li>
                      <a className="message" href="#">
                        <img
                          src={publicUrl + "/assets/img/icons/8.png"}
                          alt="img"
                        />
                      </a>
                    </li>
                    <li>
                      <Link
                        className="btn btn-yellow"
                        to={{
                          state: { propertyDetails: item },
                          pathname: "property-details",
                        }}
                      >
                        View Details
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default RecomandProperties;
